import React from 'react';
import Select from '@amzn/awsui-components-core/select';
import { STUDIO_NATIVE_OPTION_LIMIT } from 'src/components/star-grid/reportStudioConstants';
import { studioSelectOptions, studioSelectedOption } from 'src/components/star-grid/utils/studioSelect';
import type { StudioOption } from 'src/components/star-grid/reportStudio.types';
import styles from 'src/components/star-grid/components/styles/ReportStudio.module.scss';
interface Props {
  readonly label: string;
  readonly value: string;
  readonly options: readonly StudioOption[];
  readonly disabled?: boolean;
  readonly onChange: (id: string) => void;
  readonly testId?: string;
  /** Shown while nothing is chosen; without it an empty value reads as a dash. */
  readonly placeholder?: string;
}
export const StudioCompactSelect: React.FC<Props> = ({ label, value, options, disabled, onChange, testId, placeholder }) =>
  options.length > STUDIO_NATIVE_OPTION_LIMIT ? (
    <Select
      className={styles.compactPicker}
      ariaLabel={label}
      data-testid={testId}
      disabled={disabled}
      options={studioSelectOptions(options)}
      selectedOption={!value && placeholder ? null : studioSelectedOption(options, value)}
      placeholder={placeholder}
      virtualScroll
      filteringType="auto"
      expandToViewport
      onChange={({ detail }) => onChange(detail.selectedOption.value ?? '')}
    />
  ) : (
    <select
      className={styles.compactSelect}
      aria-label={label}
      value={value}
      disabled={disabled}
      data-testid={testId}
      onChange={(event) => onChange(event.target.value)}
    >
      {!options.some((option) => option.id === value) && (
        <option value={value} disabled={!value && Boolean(placeholder)}>
          {value || placeholder || '—'}
        </option>
      )}
      {options.map((option) => (
        <option key={option.id} value={option.id}>
          {option.label}
        </option>
      ))}
    </select>
  );
